import config from 'config';
import { useQueryClient } from '@tanstack/react-query';
import ownFetch from 'utils/own-fetch';

/* eslint-disable import/prefer-default-export */
export const useSubscriptionApi = () => {
  const queryClient = useQueryClient();
  const orgToken: any = queryClient.getQueryState(['subscription', 'token']);

  return {
    createCheckoutSession: ({
      merchantId,
      productFamily,
      redirectUrl,
      locale,
    }: {
      merchantId: string;
      productFamily: 'shore_bm' | 'shore_pos';
      redirectUrl: string;
      locale: string;
    }) => {
      const payload = {
        merchant_id: merchantId,
        product_family: productFamily,
        redirect_url: redirectUrl,
        locale,
        metadata: {
          app: 'pos-web',
          channel: 'self-service',
        },
      };

      return ownFetch(
        `${config.SUBSCRIPTION_APP_URL}/v3/subscription/checkout_sessions`,
        'POST',
        payload,
        {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${orgToken?.data?.org_token}`,
        }
      );
    },
  };
};
